import * as React from 'react';
import styled from 'styled-components';

import { Modal } from '@process-advisor/process-miner/components/modal/modal';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Text} from '@process-advisor/process-miner/modals/text';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/modals/discoveryRules/section';
import { saveDiscoveryChildDiscoveryRules } from '@process-advisor/process-miner/processMiner/processMiner';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type DiscoveryRuleModalProps } from '@process-advisor/process-miner/api/methods/modals/discoveryRuleModal';
import { DataGrid } from '@process-advisor/process-miner/modals/discoveryRules/dataGrid';
import * as _ from 'lodash/fp';
import { SingleBlock } from '@process-advisor/process-miner/slicers/singleBlock';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';
import { JsonEditor as JSONEditor } from 'jsoneditor-react'
import 'jsoneditor-react/es/editor.min.css'

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    padding-bottom: 5px;
    margin-top: 10px
`;

const RowApply = styled.div`
  display: grid;
  justify-content: center;
  padding-top: 10px;
`;

const IssuesWrapper = styled.div`
    margin-top: 7px;
    font-weight: bold;
`;

const DiscoveryRuleWrapper = styled.div`
    margin-top: 4px;
`;

const categories = [
    { value: 'Performance', label: 'Performance' },
    { value: 'Compliance', label: 'Compliance' },
    { value: 'Cost', label: 'Cost' },
];

const types = [
    { value: 'Filter', label: 'Filter' },
    { value: 'Discovery', label: 'Discovery' },
];

const filtersGridColumns = [
    {
        field: 'type',
        headerName: 'Type',
        width: '150px'
    },
    {
        field: 'description',
        headerName: 'Description',
        flex: 1
    },
];

const variantGridColumns = () => [
    {
        field: 'variant',
        headerName: 'Variant',
        flex: 1
    },
    {
        field: apiProvider.getEntityUpper() + 's',
        headerName: apiProvider.getEntityUpper() + 's',
        width: 105,
        sort: 'desc',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        width: 110,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        width: 110,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
];

const activityGridColumns = () => [
    {
        field: 'activity',
        headerName: 'Activity',
        flex: 1
    },
    {
        field: apiProvider.getEntityUpper() + 's',
        headerName: apiProvider.getEntityUpper() + 's',
        width: 105,
        sort: 'desc',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        width: 110,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        width: 110,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },

];

const stepGridColumns = () => [
    {
        field: 'step',
        headerName: 'Step',
        flex: 1
    },
    {
        field: apiProvider.getEntityUpper() + 's',
        headerName: apiProvider.getEntityUpper() + 's',
        width: 105,
        sort: 'desc',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        width: 110,
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        width: 110,
        filter: 'agNumberColumnFilter',
        type: 'rightAligned',
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },

];


export type calculate_cost_impactProps = {calculate_cost_impact?: boolean}
export type automation_opportunityProps = {automation_opportunity?: boolean}
export type save_variantsProps = {save_variants?: boolean}
export type save_activitiesProps = {save_activities?: boolean}
export type save_stepsProps = {save_steps?: boolean}

export type Row = {};
export const DiscoveryRuleModal = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [discoveryRule, setDiscoveryRule] = React.useState<string>('');
    const [tempFilters, setTempFilters] = React.useState<any[]>([]);
    const [tasks, setTasks] = React.useState(0);
    const [events, setEvents] = React.useState(0);
    const [category, setCategory] = React.useState<string>('Performance');
    const [type, setType] = React.useState<string>('Filter');
    const [calculate_cost_impact, setCalculateCostImpact] = React.useState<boolean>(true);
    const [automation_opportunity, setAutomationOpportunity] = React.useState<boolean>(true);
    const [conditionsJSON, setConditionsJSON] = React.useState<any[]>([])

    const [mode, setMode] = React.useState('');
    const [discovery_rule_id, setDiscoveryRuleID] = React.useState<number>(0);
    const [discoveryIndex, setDiscoveryIndex] = React.useState<number>(0);
    const [saveOK, setSaveOK] = React.useState<boolean>(false);
    const [enableSaveVariants,setEnableSaveVariants] = React.useState<boolean>(false);
    const [enableSaveSteps,setEnableSaveSteps] = React.useState<boolean>(false);
    const [enableSaveActivities,setEnableSaveActivities] = React.useState<boolean>(false);
    const [save_variants,setSaveVariants] = React.useState<boolean>(false);
    const [save_steps,setSaveSteps] = React.useState<boolean>(false);
    const [routesDataChanged,setRoutesDataChanged] = React.useState<boolean>(false);
    const [save_activities,setSaveActivities] = React.useState<boolean>(false);
    const [filter_variants,setFilterVariants] = React.useState<any>(false);
    const [filter_steps,setFilterSteps] = React.useState<any>(false);
    const [filter_activities,setFilterActivities] = React.useState<any>(false);
    const [filters, setFilters] = React.useState();
    const [discoveryRuleRows, setDiscoveryRuleRows] = React.useState();
    const [discoveryRuleData, setDiscoveryRuleData] = React.useState();
    const [detailRows, setDetailRows] = React.useState();
    const [detailData, setDetailData] = React.useState();
    const [detailColumns, setDetailColumns] = React.useState<any>();
    const [discoveryRuleColumns, setDiscoveryRuleColumns] = React.useState();

    const onDiscoveryRuleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDiscoveryRule(event.target.value);
        if (event.target.value !== '') {setSaveOK(true)} else {setSaveOK(false)}
    };

    const onCategoryChange = (category: string) => {
        setCategory(category);
        setSaveOK(true)
    };

    const onTypeChange = (type: string) => {
        setType(type);
        setSaveOK(true)
    };

    const checkSaveType = React.useCallback((mode: string, filters: any[]) => {
        let variantsExist = 0
        let stepsExist = 0
        let activitiesExist = 0
        setEnableSaveVariants(false)
        setEnableSaveActivities(false)
        setEnableSaveSteps(false)
        let localDI = 0
        for (let i = 0; i < filters.length; i++) {
            if (filters[i].steps?.length > 0 && filters[i].type === 'discovery') {
                stepsExist ++
                if (stepsExist === 1) {
                    setFilterSteps(filters[i].steps)
                    localDI = i
                }
            }
            if (filters[i].activities?.length > 0 && filters[i].type === 'discovery') {
                activitiesExist ++
                if (activitiesExist === 1) {
                    setFilterActivities(filters[i].activities)
                    localDI = i
                }
            }
            if (filters[i].variants?.length > 0 && filters[i].type === 'discovery') {
                variantsExist ++
                if (variantsExist === 1) {
                    setFilterVariants(filters[i].variants)
                    localDI = i
                }
            }
        }
        setDiscoveryIndex(localDI)
        
        if (variantsExist === 1 && stepsExist === 0 && activitiesExist === 0) {
            setDetailRows(filters[localDI].variants.map((row: any, id: number) => ({ id, ...row })));
            setEnableSaveVariants(true)
            setDetailColumns(variantGridColumns)
        } 
        if (variantsExist === 0 && stepsExist === 0 && activitiesExist === 1) {
            setDetailRows(filters[localDI].activities.map((row: any, id: number) => ({ id, ...row })));
            setEnableSaveActivities(true)
            setDetailColumns(activityGridColumns)
        }
        if (variantsExist === 0 && stepsExist === 1 && activitiesExist === 0) {
            setDetailRows(filters[localDI].steps.map((row: any, id: number) => ({ id, ...row })));
            setEnableSaveSteps(true)
            setDetailColumns(stepGridColumns)
        }

        setConditionsJSON(filters)
    }, []);

    useApiListener(
        Event.openDiscoveryRuleModal,
        ({ data }: DiscoveryRuleModalProps) => {
            setIsOpen(true);
            setMode(data.mode)
            setDiscoveryRuleID(data.discovery_rule_id)
            setDiscoveryRule(data.discovery_rule);
            setCategory(data.category);
            setType(data.type);
            setTasks(data.tasks)
            setEvents(data.events)
            setFilters(data.filters)
            setTempFilters(data.filters)
            setConditionsJSON(data.filters);
            setCalculateCostImpact(data.calculate_cost_impact)
            setAutomationOpportunity(data.automation_opportunity)
            setDiscoveryRuleRows(data.filterSummary);
            setEnableSaveVariants(false);
            setEnableSaveSteps(false);
            setEnableSaveActivities(false);
            if (data.mode === 'edit') {
                setSaveVariants(data.save_variants);
                setSaveSteps(data.save_steps);
                setSaveActivities(data.save_activities);
            } else {
                setSaveVariants(false);
                setSaveSteps(false);
                setSaveActivities(false);
            }
            checkSaveType(data.mode, data.filters);
        }
    );

    React.useEffect(() => {
        setConditionsJSON(conditionsJSON)
        setRoutesDataChanged(true)
    }, [conditionsJSON]);

    React.useEffect(() => {
        setDiscoveryRuleData(discoveryRuleRows)
    }, [discoveryRuleRows]);

    React.useEffect(() => {
        setDetailData(detailRows)
    }, [detailRows]);

    const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

    const onOk = async () => {
        let uniqueFilters = []
        if (conditionsJSON.length === 1) uniqueFilters = conditionsJSON
        else {
            let jsonObject = conditionsJSON.map(JSON.stringify);
            let uniqueSet = new Set(jsonObject);
            uniqueFilters = Array.from(uniqueSet).map(JSON.parse)
        }
        let discovery_rule_detail: any[] = []
        if (mode === 'edit') apiProvider.deleteDiscoveryRule(({ discovery_rule_id: discovery_rule_id }));

        JSON.stringify(conditionsJSON)
        openProgressModal({status: 'Saving Discovery Rule'})
        await sleep(200) // needed to display Progress
        let discovery_rule_type = 'parent'
        if (save_steps === true || save_activities === true || save_variants === true) discovery_rule_type = 'parent_discovery'

        await apiProvider.processDiscoveryRule({discoveryRule: {
            discovery_rule_id: discovery_rule_id,
            discovery_rule: discoveryRule,
            automation_opportunity: automation_opportunity,
            id: '',
            mode: 'new',
            category: category,
            type: type,
            discovery_rule_type: discovery_rule_type,
            discovery_rule_detail: discovery_rule_detail,
            filters: uniqueFilters,
            tasks: tasks,
            events: events,
            calculate_cost_impact: calculate_cost_impact,
            save_activities: save_activities,
            save_steps: save_steps,
            save_variants: save_variants,
            filter_activities: filter_activities,
            filter_variants: filter_variants,
            filter_steps: filter_steps,
        }, savedDiscoveryRuleID: '', source :'saveParentDiscoveryRule'})

        if (discovery_rule_type === 'parent_discovery')  await saveDiscoveryChildDiscoveryRules()
 
        closeProgressModal()
        apiProvider.setAction_Visualizer({})
        apiProvider.setDiagramVisualizer()
    };

    React.useEffect(() => {
        //setDiscoveryRule('')
    }, [isOpen]);

    const onChangeCCI = _.curry((
        key: keyof calculate_cost_impactProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setCalculateCostImpact(e.target.checked);
        setSaveOK(true)
    });

    const onChangeAO = _.curry((
        key: keyof automation_opportunityProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setAutomationOpportunity(e.target.checked);
        setSaveOK(true)
    });

    const onChangeSV = _.curry((
        key: keyof save_variantsProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSaveVariants(e.target.checked);
        setSaveOK(true)
    });

    const onChangeSA = _.curry((
        key: keyof save_activitiesProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSaveActivities(e.target.checked);
        setSaveOK(true)
    });

    const onChangeSS = _.curry((
        key: keyof save_stepsProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSaveSteps(e.target.checked);
        setSaveOK(true)
    });

    function updateJSON(props: any) {
        setConditionsJSON(props.newData)
        setSaveOK(true)
    }

    return (
        <Modal title='DiscoveryRule' open={isOpen} onClose={() => setIsOpen(false)} onOk={onOk} saveOK={saveOK} width={'900px'}>
            <Wrapper>
                <SingleBlock width="25%">
                    <Section title='DiscoveryRule'/>
                </SingleBlock>
                <SingleBlock width="75%">
                    <DiscoveryRuleWrapper>
                        <Text width='500px' multiline maxRows={5} value={discoveryRule} onChange={onDiscoveryRuleChange} />
                    </DiscoveryRuleWrapper>
                </SingleBlock>
                <SingleBlock width="25%">
                    <Section title='Criteria:'/>
                </SingleBlock>
                <SingleBlock width="75%">
                <DataGrid
                    rows={discoveryRuleRows}
                    columns={filtersGridColumns}
                    height="110px" />
                </SingleBlock>
                <SingleBlock width="25%">
                    <Section title='Conditions:'/>
                </SingleBlock>
                <SingleBlock width="75%">
                    <JSONEditor
                        mode="tree"
                        history
                        value={conditionsJSON}
                        onChange={updateJSON}
                    />    
                </SingleBlock>

                <SingleBlock width="25%">
                    <Section title={apiProvider.getEntityUpper() + 's'}/>
                </SingleBlock>
                <SingleBlock width="75%">
                    <IssuesWrapper>{tasks}</IssuesWrapper>
                </SingleBlock>

                <SingleBlock width="25%">
                    <Section title='Category'/>
                </SingleBlock>           
                <SingleBlock width="25%">         
                    <Dropdown label='' value={category} onChange={onCategoryChange} options={categories} />
                </SingleBlock>                    

                <SingleBlock width="25%">
                    <Section title='Type'/>
                </SingleBlock>           
                <SingleBlock width="25%">         
                    <Dropdown label='' value={type} onChange={onTypeChange} options={types} />
                </SingleBlock>                    


                <SingleBlock width="25%">                    
                    <Section title='Automation opportunity'/>
                </SingleBlock>                            
                <SingleBlock width="25%">
                    <Checkbox
                        label=''
                        checked={!!automation_opportunity}
                        handleOnChange={onChangeAO('automation_opportunity')} />
                </SingleBlock>                        
                <SingleBlock width="25%">
                    <Section title='Calculate cost impact'/>
                </SingleBlock>                        
                <SingleBlock width="25%">
                    <Checkbox
                        label=''
                        checked={!!calculate_cost_impact}
                        handleOnChange={onChangeCCI('calculate_cost_impact')} />                
                </SingleBlock>
                { enableSaveSteps === true ?
                    <SingleBlock width="25%">
                        <Section title='Create discoveryRules for steps'/>
                    </SingleBlock>
                : null }
                { enableSaveSteps === true ?
                    <SingleBlock width="75%">
                        <Checkbox
                            label=''
                            checked={!!save_steps}
                            handleOnChange={onChangeSS('save_steps')} />
                    </SingleBlock>
                : null }
                { enableSaveSteps === true ? 
                    <SingleBlock width="25%">
                        <Section title='Steps:'/>
                    </SingleBlock>
                : null }
                { enableSaveSteps === true ? 
                    <SingleBlock width="75%">
                        <DataGrid
                            rows={detailRows}
                            columns={detailColumns}
                            height="210px" />
                    </SingleBlock>
                : null }                    
                { enableSaveActivities === true ?
                    <SingleBlock width="25%">
                        <Section title='Create discoveryRules for activities'/>
                    </SingleBlock>
                : null }
                { enableSaveActivities === true ?
                    <SingleBlock width="75%">
                        <Checkbox
                            label=''
                            checked={!!save_activities}
                            handleOnChange={onChangeSA('save_activities')} />
                    </SingleBlock>
                : null }
                { enableSaveActivities === true ? 
                    <SingleBlock width="25%">
                        <Section title='Activities:'/>
                    </SingleBlock>
                : null }
                { enableSaveActivities === true ? 
                    <SingleBlock width="75%">
                        <DataGrid
                            rows={detailRows}
                            columns={detailColumns}
                            height="210px" />
                    </SingleBlock>
                : null }                    
                { enableSaveVariants === true ?
                    <SingleBlock width="25%">
                        <Section title='Create discoveryRules for variants'/>
                    </SingleBlock>
                : null }
                { enableSaveVariants === true ?
                    <SingleBlock width="75%">
                        <Checkbox
                            label=''
                            checked={!!save_variants}
                            handleOnChange={onChangeSV('save_variants')} />
                    </SingleBlock>
                : null }
                { enableSaveVariants === true ? 
                    <SingleBlock width="25%">
                        <Section title='Variants:'/>
                    </SingleBlock>
                : null }
                { enableSaveVariants === true ? 
                    <SingleBlock width="75%">
                        <DataGrid
                            rows={detailRows}
                            columns={detailColumns}
                            height="210px" />
                    </SingleBlock>
                : null }                    

            </Wrapper>
        </Modal>
    );
};